import { GridColDef } from '@mui/x-data-grid';

export type Columns = { field: string; headerName?: string; flex?: number };
export type Rows = { id: string; [key: string]: string | number | null };
export type PaginationModel = {
  page: number;
  pageSize: number;
};
export type FiltersState = {
  sources?: string[];
  selected_only?: true | false;
  variant_selection?: number | undefined;
  filters?: {
    vcf_filters?: Record<string, string | number>;
    annotation_filters?: Record<string, string | number>;
    hpo_filters?: string[]; // Allow hpo_filters to be an array
    gene_filters?: {
      include: string[];
      exclude: string[];
    };
    gene_panel_ids?: string[];
  };
};

export const reportSteps = [
  'Prioritization & Filtration',
  'Variants Interpretation',
  'Validate Results',
  'Preview Report',
  'Generate Report',
];

interface OutputData {
  results: {
    headers: string[];
    rows: Record<string, string | number | null>[];
    next: string | null;
  };
  row_count?: number;
}

export function processOutputData(outputData: OutputData) {
  const { headers, rows, next } = outputData.results;

  const hideColumns = new Set(['id']);
  const excludeColumns = new Set(['']);

  const columns = headers
    .filter((header) => !excludeColumns.has(header) && !hideColumns.has(header))
    .map((header) => ({
      field: header,
      headerName: header.replace(/_/g, ' '),
      flex: 1,
    }));

  const formattedRows: Rows[] = rows.map((row) =>
    Object.entries(row).reduce((acc, [key, value]) => {
      if (!excludeColumns.has(key)) {
        acc[key] = value === null ? '-' : value;
      }
      return acc;
    }, {} as Rows),
  );

  return {
    columsOutput: columns as GridColDef[],
    rowsOutput: formattedRows,
    cursorOutput: next,
    rowCountOutput: outputData.row_count || 0,
  };
}

export interface Gene {
  hgnc_id: string;
  symbol: string;
  name: string;
  refseq: string;
}

export interface Panel {
  panel_name: string;
}

export type VariantDetails = {
  id: string;
  selected_variant_id: string;
  uploaded_variation: string;
  location: string;
  chromosome: string;
  start_position: string;
  end_position: string;
  allele: string;
  qual: number;
  info: string;
  result_format: string;
  s103: string;
};

export const formatKey = (key: string) =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

export const initialComments = [
  {
    id: '1234',
    comment_type: 'general',
    comment: 'This variant needs additional review',
    created_by_email: 'muhammad.sukeri@gmail.com',
    created_at: '2025-08-11T07:01:17.726335Z',
  },
  {
    id: '5555',
    comment_type: 'general',
    comment: 'This variant needs additional review',
    created_by_email: 'muhammad.sukeri@gmail.com',
    created_at: '2025-08-11T07:01:17.726335Z',
  },
];

export type VariantComment = {
  id: string;
  comment_type: string;
  comment: string;
  created_by_email: string;
  created_at: string;
};
